export class WindowsApplications {
	static readonly Iosim = 'iosim';
	static readonly IosimPa = 'iosim_pa';
	static readonly IosimCa = 'iosim_ca';
	static readonly IosimGo = 'iosim_go';
	static readonly IosimPro = 'iosim_pro';
	static readonly Orthocad = 'orthocad';
}
